import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import CoachAvatar from "./CoachAvatar";
import useAvatarStore from "../stores/avatarStore";
import { BrainCircuit, Volume2, Mic } from "lucide-react";

const AvatarScene = () => {
  const { coachState, isMuted } = useAvatarStore();

  const getStatusText = () => {
    switch (coachState) {
      case "speaking":
        return "Coach is speaking…";
      case "listening":
        return isMuted ? "Mic muted — unmute to speak" : "Listening…";
      case "thinking":
        return "Coach is thinking…";
      default:
        return "Waiting…";
    }
  };

  const getStatusIcon = () => {
    switch (coachState) {
      case "speaking":
        return <Volume2 className="w-3.5 h-3.5 text-secondary" />;
      case "listening":
        return <Mic className="w-3.5 h-3.5 text-emerald-400" />;
      case "thinking":
        return <BrainCircuit className="w-3.5 h-3.5 text-amber-400 animate-spin" />;
      default:
        return <div className="w-1.5 h-1.5 rounded-full bg-gray-500" />;
    }
  };

  return (
    <div className="relative w-full h-full bg-gray-50 flex flex-col justify-between">
      {/* Immersive Scene */}
      <div className="w-full h-full relative">
        <CoachAvatar />
      </div>

      {/* Floating Status Indicator at bottom left */}
      <AnimatePresence mode="wait">
        <motion.div
          key={coachState}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -20 }}
          className="absolute bottom-20 left-6 z-20 backdrop-blur-xl bg-white/90 border border-gray-200 px-4 py-2 rounded-full flex items-center gap-2.5 shadow-md"
        >
          {/* Animated dot indicator */}
          <span className="relative flex h-2 w-2">
            {coachState !== "idle" && (
              <span
                className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${
                  coachState === "listening"
                    ? isMuted
                      ? "bg-rose-400"
                      : "bg-emerald-400"
                    : coachState === "speaking"
                      ? "bg-secondary"
                      : "bg-amber-400"
                }`}
              ></span>
            )}
            <span
              className={`relative inline-flex rounded-full h-2 w-2 ${
                coachState === "listening"
                  ? isMuted
                    ? "bg-rose-500"
                    : "bg-emerald-500"
                  : coachState === "speaking"
                    ? "bg-secondary"
                    : coachState === "thinking"
                      ? "bg-amber-500"
                      : "bg-gray-500"
              }`}
            ></span>
          </span>

          <div className="flex items-center gap-1.5 text-xs font-bold text-gray-700">
            {getStatusIcon()}
            <span>{getStatusText()}</span>
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default AvatarScene;
